import { ArchiveReason } from '@/constants'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum TransactionRuleUse {
  CATEGORIZATION = 'CATEGORIZATION',
  CLARIFICATION = 'CLARIFICATION',
}

export enum TransactionRuleType {
  EXACT_MATCH = 'EXACT_MATCH',
  CONTAINS_WORD = 'CONTAINS_WORD',
  REGEX = 'REGEX',
  MATCHES_DPF_CATEGORY = 'MATCHES_DPF_CATEGORY',
  MATCHES_MERCHANT_NAME = 'MATCHES_MERCHANT_NAME',
}

export enum TransactionRuleCategoryType {
  personal = 'personal',
  business = 'business',
}

export interface TransactionRule {
  id: number
  ruleUse: TransactionRuleUse
  ruleText: string
  ruleType: TransactionRuleType
  transactionCategoryType: TransactionRuleCategoryType | null
  transactionCategoryId: number | null
  userId: number | null
  amountInCents: number | null
  createdAt: string
  updatedAt: string
  archivedAt?: string | null
  archivedBy?: number | null
  archiveReason?: ArchiveReason | null
  restoredFromRuleId?: number | null
  restoredAs?: { id: number } | null
}

export interface TransactionRulesState {
  [key: number]: TransactionRule
}

const transactionRulesSlice = createSlice({
  name: 'transactionRules',
  initialState: {} as TransactionRulesState,
  reducers: {
    receiveTransactionRules: (
      state,
      action: PayloadAction<{ [key: number]: TransactionRule }>
    ) => ({ ...state, ...action.payload }),
    receiveSingleTransactionRule: (
      state,
      action: PayloadAction<TransactionRule>
    ) => {
      state[action.payload.id] = action.payload
    },
  },
})

export default transactionRulesSlice.reducer

export const { receiveTransactionRules, receiveSingleTransactionRule } =
  transactionRulesSlice.actions
